import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SidebarNav from "../sidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  getCoin,
  getTradingPair,
  getUser,
} from "../../../service/api";
import actions from "../../../redux/user/actions";
import moment from "moment";
import {
  FiUsers,
  FiRefreshCw,
  FiTrendingUp,
  FiBarChart2,
  FiActivity,
  FiArrowRight,
  FiList,
  FiArrowUpCircle,
  FiArrowDownCircle,
} from "react-icons/fi";

const KPI_CARDS = (data) => [
  { label: "Total Users",   value: data.user, color: "#1b5a90", bg: "#eef4fb", Icon: FiUsers },
  { label: "Total Coins",   value: data.coin, color: "#28a745", bg: "#eaf7ee", Icon: FiTrendingUp },
  { label: "Trading Pairs", value: data.pair, color: "#fd7e14", bg: "#fff4e5", Icon: FiRefreshCw },
];

const QUICK_LINKS = [
  { label: "Finance Overview",  desc: "Fees, profit & USDT rate",    href: "/admin/finance/overview",          color: "#1b5a90", bg: "#eef4fb", Icon: FiBarChart2 },
  { label: "Trading History",   desc: "Orders and trade ledger",      href: "/admin/order",           color: "#28a745", bg: "#eaf7ee", Icon: FiActivity },
  { label: "INR Deposits",      desc: "Review deposit requests",      href: "/admin/finance/inr-deposits",      color: "#6f42c1", bg: "#f4eefb", Icon: FiArrowUpCircle },
  { label: "INR Withdrawals",   desc: "Review withdrawal requests",   href: "/admin/finance/inr-withdrawals",   color: "#e83e8c", bg: "#fdf0f8", Icon: FiArrowDownCircle },
  { label: "TDS Reports",       desc: "Annual & monthly TDS data",    href: "/admin/finance/tds",       color: "#fd7e14", bg: "#fff4e5", Icon: FiList },
  { label: "User Management",   desc: "Accounts, KYC, limits",        href: "/admin/user",                 color: "#0dcaf0", bg: "#e8fafe", Icon: FiUsers },
];

const Dashboard = () => {
  const userData = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [data, setData] = useState({ user: 0, coin: 0, pair: 0 });

  const fetchData = async () => {
    try {
      const [userRes, coinRes, pairRes] = await Promise.all([
        getUser({ pagination: false }),
        getCoin({ pagination: false }),
        getTradingPair({ pagination: false }),
      ]);

      const newData = {
        user: userRes?.status ? userRes.data.total : 0,
        coin: coinRes?.status ? coinRes.data.total : 0,
        pair: pairRes?.status ? pairRes.data.total : 0,
      };

      if (userRes?.status) {
        dispatch(actions.setUserList(userRes.data.result));
      }

      setData(newData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="main-wrapper">
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">

          {/* Page Header */}
          <div className="page-header py-3 mb-4">
            <div className="row align-items-center">
              <div className="col-sm-12">
                <h3 className="page-title mb-1">
                  Welcome back, {userData?.user?.name || "Admin"}
                </h3>
                <p style={{ color: "#8a94a6", fontSize: 13, margin: 0 }}>
                  {moment().format("dddd, MMMM D, YYYY")} — Here's your platform overview.
                </p>
              </div>
            </div>
          </div>

          {/* KPI Cards */}
          <div className="row g-3 mb-4">
            {KPI_CARDS(data).map(({ label, value, color, bg, Icon }) => (
              <div key={label} className="col-xl-4 col-sm-6 col-12">
                <div className="card" style={{ borderRadius: 12, border: "1px solid #e9ecef", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                  <div className="card-body" style={{ padding: "20px 24px" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
                      <div style={{ width: 50, height: 50, borderRadius: 12, background: bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Icon size={22} color={color} />
                      </div>
                      <div style={{ fontSize: 34, fontWeight: 800, color: "#1a1a2e", lineHeight: 1 }}>
                        {value.toLocaleString()}
                      </div>
                    </div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>{label}</div>
                    <div style={{ height: 4, background: "#f1f5f9", borderRadius: 2, marginTop: 10 }}>
                      <div style={{ height: 4, width: "50%", background: color, borderRadius: 2 }} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Quick Access */}
          <div style={{ marginBottom: 12 }}>
            <h6 style={{ fontSize: 15, fontWeight: 700, color: "#1a1a2e", marginBottom: 14 }}>Quick Access</h6>
          </div>
          <div className="row g-3">
            {QUICK_LINKS.map(({ label, desc, href, color, bg, Icon }) => (
              <div key={label} className="col-xl-4 col-sm-6 col-12">
                <Link to={href} style={{ textDecoration: "none" }}>
                  <div
                    className="card"
                    style={{ borderRadius: 12, border: "1px solid #e9ecef", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", cursor: "pointer", transition: "box-shadow 0.15s, border-color 0.15s" }}
                    onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 4px 18px rgba(0,0,0,0.10)"; e.currentTarget.style.borderColor = color + "44"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)"; e.currentTarget.style.borderColor = "#e9ecef"; }}
                  >
                    <div className="card-body" style={{ padding: "18px 20px" }}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                          <div style={{ width: 44, height: 44, borderRadius: 10, background: bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <Icon size={20} color={color} />
                          </div>
                          <div>
                            <div style={{ fontWeight: 700, fontSize: 14, color: "#1a1a2e" }}>{label}</div>
                            <div style={{ fontSize: 12, color: "#8a94a6", marginTop: 2 }}>{desc}</div>
                          </div>
                        </div>
                        <FiArrowRight size={16} color="#d1d5db" />
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Dashboard;
